module.exports = __webpack_public_path__ + "img/招聘求职客服弹窗.6d4ccfb0.png";